(function($) {

	$.fn.msxiSelectmenu = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxiSelectmenu.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            $this.selectmenu(eOpts);
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiSelectmenu.defaults = {
		style: 'popup',
        handleWidth: 18,
        wrapperElement: "<span class='select-menu-wrapper' />",
        select: function(e, object){
            var value = $(this).find('option').eq(object.index).val();
            if(value.indexOf('/') === 0)
            {
                window.location = value;
            }
        },
        icons: []
	};

})(jQuery);